import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ProductDetailsService {
  url: any = environment.API_URL;

  constructor(private http: HttpClient) { }

  getUsers(data: any) {
    return this.http.get(this.url + `customer/customer-submissions-product?limit=${data.limit}&page=${data.page}`);
  }

  getBusinessPayload(id: any) {
    return this.http.get(this.url + `customer/customer-submissions-product/${id}`);
  }
}
